import * as React from "react";
import * as _ from "underscore";

interface MaskedAccountNumberProps {
  accountNumber: string;
}

class MaskedAccountNumber extends React.Component<
  MaskedAccountNumberProps,
  any
> {
  constructor(props: MaskedAccountNumberProps) {
    super(props);
    this.state = { hidden: true };
  }

  hiddenAccountNumber() {
    const num = this.props.accountNumber;
    return "x".repeat(num.slice(0, -4).length) + num.slice(-4);
  }

  toggleHide(ev) {
    ev.stopPropagation();
    this.setState({ hidden: !this.state.hidden });
  }

  render() {
    return (
      <span onClick={this.toggleHide.bind(this)}>
        {this.state.hidden
          ? this.hiddenAccountNumber()
          : this.props.accountNumber}
      </span>
    );
  }
}

export default MaskedAccountNumber;
